import { ExternalGetUiAssetsRequest as a, ExternalSubscriptionServiceClientImpl as s, ExternalUpdateSubscriptionRequest as o, ExternalCreateOrUpdateSubscriptionRequest as c, ExternalGetSquareOneSubscriptionInfoRequest as u, ExternalGetPlanGroupRequest as l, ExternalGetBillerLocationTokenRequest as p, ExternalListTrialsRequest as S, ExternalGetPricingInfoRequest as E, ExternalGetOrSetSquareOneEligibilityRequest as O, ExternalSubscriptionServiceDefinition as n } from "../../../libs/shared/types-protos/dist/squareup/sub2/v3/external/external_subscription_service.js";
import I from "../../utils/rpc.js";
const x = "/api/v3/subscriptions/external/ListTrials", G = "/api/v3/subscriptions/external/GetOrSetSquareOneEligibility", T = "/api/v3/subscriptions/external/GetPricingInfo", b = "/api/v3/subscriptions/external/GetBillerLocationToken", _ = "/api/v3/subscriptions/external/CreateOrUpdateSubscription", q = "/api/v3/subscriptions/external/UpdateSubscription", N = "/api/v3/subscriptions/external/GetPlanGroup", P = "/api/v3/subscriptions/external/GetSquareOneSubscriptionInfo", m = "/api/v3/subscriptions/external/GetUiAssets", f = I({
  urlForMethod: (e, t, i) => {
    switch (i) {
      case n.methods.externalGetOrSetSquareOneEligibility.name:
        return G;
      case n.methods.externalGetPricingInfo.name:
        return T;
      case n.methods.externalListTrials.name:
        return x;
      case n.methods.externalGetBillerLocationToken.name:
        return b;
      case n.methods.externalCreateOrUpdateSubscription.name:
        return _;
      case n.methods.externalUpdateSubscription.name:
        return q;
      case n.methods.externalGetPlanGroup.name:
        return N;
      case n.methods.externalGetSquareOneSubscriptionInfo.name:
        return P;
      case n.methods.externalGetUiAssets.name:
        return m;
      default:
        return e;
    }
  }
}), r = new s(f);
async function R() {
  const e = O.create();
  return (await r.externalGetOrSetSquareOneEligibility(e)).squareOneEligibility;
}
async function g(e) {
  const t = E.create(e);
  return await r.externalGetPricingInfo(t);
}
async function L(e) {
  const t = S.create(e);
  return await r.externalListTrials(t);
}
async function y(e) {
  const t = p.create(e);
  return await r.externalGetBillerLocationToken(t);
}
async function A(e) {
  const t = c.create(e);
  return await r.externalCreateOrUpdateSubscription(t);
}
async function v(e) {
  const t = o.create(e);
  return await r.externalUpdateSubscription(t);
}
async function C(e) {
  const t = l.create(e);
  return await r.externalGetPlanGroup(t);
}
async function D(e) {
  const t = u.create(e);
  return await r.externalGetSquareOneSubscriptionInfo(t);
}
async function h(e) {
  const t = a.create(e);
  return await r.externalGetUiAssets(t);
}
export {
  _ as CREATE_OR_UPDATE_SUBSCRIPTION_ENDPOINT,
  b as GET_BILLER_LOCATION_TOKEN_ENDPOINT,
  G as GET_OR_SET_SQUARE_ONE_ELIGIBILITY_ENDPOINT,
  N as GET_PLAN_GROUP_ENDPOINT,
  T as GET_PRICING_INFO_ENDPOINT,
  P as GET_SQUARE_ONE_SUBSCRIPTION_INFO_ENDPOINT,
  m as GET_UI_ASSETS_ENDPOINT,
  x as LIST_TRIALS_ENDPOINT,
  q as UPDATE_SUBSCRIPTION_ENDPOINT,
  A as createOrUpdateSubscription,
  y as getBillerLocationToken,
  C as getPlanGroup,
  g as getPricingInfo,
  R as getSquareOneEligibility,
  D as getSquareOneSubscriptionInfo,
  h as getUiAssets,
  L as listTrials,
  r as sub2Client,
  v as updateSubscription
};
